import React from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { makeStyles } from '@material-ui/core/styles';

interface IProps {
  tabItems: any;
  selectedTab: any;
  onTabChange: any;
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    minWidth: '340px',
  },
  indicator: {
    backgroundColor: '#212121', // 선택된 탭의 밑줄 색상
  },
  tab: {
    fontFamily: "ESBuild, sans-serif",
    minWidth: '80px',
    maxWidth: 'unset',
    flex: 1,
    textTransform: 'none',
    color: '#9E9E9E', // 탭 텍스트 색상
    opacity: 1,
    '&$selected': {
      color: '#212121', // 선택된 탭 텍스트 색상
    },
  },
  selected: {}
}));

const TabBar = ({ tabItems, selectedTab, onTabChange }: IProps) => {
  const classes = useStyles();

  return (
    <Tabs
      className="tab-bar"
      value={selectedTab}
      onChange={onTabChange}
      variant="scrollable"
      scrollButtons="off"
      classes={{ root: classes.root, indicator: classes.indicator }}
    >
      {
        tabItems.map((tab) =>
          <Tab key={tab.name}
            label={tab.name}
            classes={{ root: classes.tab, selected: classes.selected }}
          />)
      }
    </Tabs>
  );
};

export default TabBar;
